import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  toggle(event) {
    if (event && event.target && (
      event.target.closest("a, button, input, select, textarea, form") ||
      event.target.closest(".drag-handle") ||
      event.target.closest('[data-turbo-frame="issue-drawer"]') ||
      event.target.closest(".category-menu-trigger") ||
      event.target.closest('[data-controller="cell-toggle"]')
    )) {
      return
    }

    this.menuTarget.classList.toggle("grid-rows-[0fr]")
    this.menuTarget.classList.toggle("grid-rows-[1fr]")

    this.menuTarget.classList.toggle("opacity-0")
    this.menuTarget.classList.toggle("opacity-100")

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180")
    }
  }
}